import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-incident-report-header',
  templateUrl: './incident-report-header.component.html',
  styleUrls: ['./incident-report-header.component.css']
})
export class IncidentReportHeaderComponent implements OnInit {

  @Input() public patientVo: object;
  @Input() public reportTitle: string;
  /** When set (e.g. incident report review route), shown in the primary header line. */
  @Input() public incidentId: number;

  constructor() { }

  ngOnInit() {
  }

}
